import clsx from "clsx";
import React, { FunctionComponent } from "react";

import HamburgerButton from "@ui/components/brand/theverge/HamburgerButton/HamburgerButton";
import VergeLogo from "@ui/components/brand/theverge/VergeLogo";
import {
  logo,
  navTextColor,
} from "@ui/components/brand/theverge/VergeStandardNavigation/VergeStandardNavigation.css";
import VergeSubscribeNav from "@ui/components/brand/theverge/VergeSubscribeNav";
import * as usdStyles from "@ui/components/navigation/Navigation/components/PrimaryNavigation/components/PrimaryNavigationMobile/PrimaryNavigationMobile.css";
import { notificationsPopover } from "@ui/components/navigation/Navigation/config/Navigation.theverge.config.css";
import { VergeNavigationVariants } from "@ui/components/navigation/Navigation/Navigation";
import NotificationsButton from "@ui/components/navigation/Notifications/NotificationsButton";
import { srOnly } from "@ui/shared-styles/accessibility.css";
import vergeLight from "@ui/themes/theverge-light.css";
import { useAnalytics } from "@voxmedia/duet-context/context/analytics-context";

import * as styles from "./VergePrimaryNavigationMobile.css";

interface Props {
  Logo: FunctionComponent<{ className?: string }>;
  hideLogo?: boolean;
  variant: VergeNavigationVariants;
}

const VergePrimaryNavigationMobile: FunctionComponent<Props> = ({
  Logo,
  hideLogo,
  variant,
}) => {
  const analytics = useAnalytics();

  const handleLogoClick = () =>
    analytics?.emit({
      event: "navigation_click",
      navigation_click: { name: "front page" },
    });

  return (
    <div className={clsx(styles.mobileContainer, navTextColor[variant])}>
      <div
        className={
          styles.innerContainer[variant === "homepage" ? "homepage" : "default"]
        }
      >
        {!hideLogo && (
          <div className={clsx(styles.logoContainer)}>
            <a href="/" onClick={handleLogoClick}>
              <span className={srOnly}>The homepage</span>
              <Logo className={clsx(usdStyles.logo, logo[variant])} />
            </a>
          </div>
        )}
        <div
          className={clsx(usdStyles.buttonsContainer, styles.buttonsContainer)}
        >
          <VergeSubscribeNav variant={variant} hideAccountLink />
          <div className={styles.notificationsContainer}>
            <NotificationsButton
              Logo={VergeLogo}
              popoverId="header-mobile"
              popoverClassName={clsx(vergeLight, notificationsPopover)}
            />
          </div>
          <HamburgerButton variant={variant} />
        </div>
      </div>
    </div>
  );
};

export default VergePrimaryNavigationMobile;
